export default {
  // / Nhận dự toán
  BUPlan: 1,

  // / Điều chỉnh dự toán
  BUPlanAdjustment: 2,

  // / Rút dự toán
  BUPlanWithdraw: 3,

  // / Chuyển khoản kho bạc
  BUTransfer: 4,

  // / Phiếu thu
  CAReceipt: 5,

  // / Phiếu chi
  CAPayment: 6,

  // / Thu tiền gửi
  BADeposit: 7,

  // / Chi tiền gửi
  BAWithDraw: 8,

  // / Tiền đang chuyển
  BATransfer: 9,

  // / Nhập kho
  INInward: 10,

  // / Xuất kho
  INOutward: 11,

  // / Chuyển kho
  INTransfer: 12,

  // / Điều chỉnh tồn kho
  INAdjustment: 13,

  // / Ghi tăng công cụ dụng cụ
  SUIncrement: 14,

  // / Ghi giảm công cụ dụng cụ
  SUDecrement: 15,

  // / Điều chuyển công cụ dụng cụ
  SUTransfer: 16,

  // / Ghi tăng tài sản cố định
  FAIncrement: 17,

  // / Ghi giảm tài sản cố định
  FADecrement: 18,

  // / Đánh giá lại tài sản cố định
  FAAdjustment: 19,

  // / Điều chuyển phòng/ban
  FATransfer: 21, // 20,

  // / Hóa đơn mua hàng, tài sản
  PUInvoice: 23, // 21,

  // / Hóa đơn bán hàng
  SAInvoice: 24, // 22,

  // / Chứng từ nghiệp vụ khác
  GeneralJournalEntry: 25, // 23,

  // / Bảng kê chứng từ thanh toán
  BUVoucherList: 26, // 24,

  // / Hủy dự toán
  BUPlanCancel: 29, // 25,

  // / Điều chỉnh kinh phí
  BUExpenseWithdrawAdjustment: 31, // 26,

  // / Chuyển tiền nội bộ
  BABankTransfer: 36, // 27,

  // / Hàng bán trả lại
  SAReturn: 37, // 28,

  // / Tạm tính thuế thu nhập doanh nghiệp
  GLProvisionalTaxInComeEnterprise: 39, // 29,

  // / Quyết toán thuế thu nhập doanh nghiệp
  GLFinalTaxInComeEnterprise: 40, // 30
};
